/* assets/article-gwa.js */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function slugify(str) {
    return String(str || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^\p{L}\p{N}]+/gu, '-')
      .replace(/^-+|-+$/g, '');
  }

  function ensureId(el, used) {
    if (!el) return '';
    const current = el.getAttribute('id');
    if (current) {
      used.add(current);
      return current;
    }
    const base = slugify(el.textContent || 'section') || 'section';
    let id = base;
    let i = 2;
    while (used.has(id)) {
      id = `${base}-${i++}`;
    }
    el.setAttribute('id', id);
    used.add(id);
    return id;
  }

  function normalizeHeadings(container) {
    // Convert H3/H4/H5 to H2 so TOC is consistent (as requested)
    const toConvert = $$('h3, h4, h5', container);
    toConvert.forEach((h) => {
      const h2 = document.createElement('h2');
      // copy text + inline content
      h2.innerHTML = h.innerHTML;
      // keep class for styling if any
      if (h.className) h2.className = h.className;
      h.parentNode && h.parentNode.replaceChild(h2, h);
    });
  }

  function comparableText(value) {
    return String(value || '')
      .toLocaleLowerCase()
      .replace(/[^\p{L}\p{N}]+/gu, '')
      .trim();
  }

  function removeRepeatedArticleTitles(root, content) {
    const articleTitle = comparableText($('.agwa-article__title', root)?.textContent);
    if (!articleTitle) return;

    $$('h1, h2, h3, h4, h5, h6', content).forEach((heading) => {
      const headingText = comparableText(heading.textContent);
      if (headingText.length >= 12 && (headingText === articleTitle || articleTitle.includes(headingText))) {
        heading.remove();
      }
    });
  }

  function buildToc(root) {
    const toc = $('[data-agwa-toc]', root);
    const content = $('[data-agwa-content]', root);
    const rte = $('[data-agwa-rte]', root);
    if (!toc || !content) return;

    removeRepeatedArticleTitles(root, content);

    // normalize headings inside main rte only (don’t touch global layout)
    if (rte) normalizeHeadings(rte);

    const used = new Set();
    const headings = $$('h2', content).filter((h) => (h.textContent || '').trim().length > 0);

    toc.innerHTML = '';
    headings.forEach((h) => {
      const id = ensureId(h, used);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${id}`;
      a.textContent = (h.textContent || '').trim();
      li.appendChild(a);
      toc.appendChild(li);
    });

    // If no headings, hide TOC box gracefully
    const tocBox = toc.closest('.agwa-toc__box');
    if (tocBox) tocBox.style.display = headings.length ? '' : 'none';
  }

  function init() {
    $$('[data-agwa-article]').forEach(buildToc);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
